import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'src/app/store';
import SpinTracking from '../SpinTracking/SpinTracking';

interface StationsTrackingProps {
  hasComparisonOn: boolean;
}

const StationsTracking: React.FC<StationsTrackingProps> = ({
  hasComparisonOn,
}) => {
  const { t } = useTranslation();

  const { songStations } = useSelector((state: RootState) => state.dashboard);

  return (
    <SpinTracking
      hasComparisonOn={hasComparisonOn}
      spinData={songStations.songStationsData}
      spinDataCompare={songStations.songStationsDataCompare}
      title={t('DASHBOARD_STATIONS_TRACKING_TITLE')}
      description={t('DASHBOARD_STATIONS_TRACKING_DESC')}
    />
  );
};

export default StationsTracking;
